import { steps, type Field, type Kind } from './model';

function source(field: Field) {
  if (field.key === 'solicitante') return 'Usuário logado — automático';
  if (field.key === 'unidade') return 'Divisão do usuário — automática';
  if (field.key === 'data') return 'Data atual — automática e editável';
  if (field.key === 'cliente') return 'Cadastro de clientes — pesquisa e seleção';
  if (field.key === 'produto') return 'Cadastro de materiais — pesquisa e seleção';
  return field.type === 'select' ? 'Opções do sistema' : 'Informado pelo usuário';
}

function rows(kind: Kind) {
  return steps[kind].flatMap((step, stepIndex) => step.fields.map((field, fieldIndex) => ({
    Ordem: `${stepIndex + 1}.${fieldIndex + 1}`,
    Seção: step.title,
    Campo: field.label,
    Chave: field.key,
    Obrigatório: field.required ? 'Sim' : 'Não',
    Tipo: field.type || 'Texto',
    Opções: field.options?.join(' | ') || '',
    Origem: source(field),
  })));
}

export async function downloadUnifiedFormModel() {
  const XLSX = await import('xlsx');
  const project = rows('projeto');
  const sample = rows('amostra');
  const projectKeys = new Set(project.map(row => row.Chave));
  const sampleKeys = new Set(sample.map(row => row.Chave));
  const consolidated = [...project, ...sample].filter((row, index, all) => all.findIndex(other => other.Chave === row.Chave) === index).map(row => ({
    Campo: row.Campo,
    Chave: row.Chave,
    'Usado em Projeto': projectKeys.has(row.Chave) ? 'Sim' : 'Não',
    'Usado em Amostra': sampleKeys.has(row.Chave) ? 'Sim' : 'Não',
    Obrigatório: row.Obrigatório,
    Tipo: row.Tipo,
    Origem: row.Origem,
    'Decisão da Aline': '',
    'Observações': '',
  }));
  const workbook = XLSX.utils.book_new();
  for (const [name, data] of [['Projeto', project], ['Amostra', sample], ['Modelo unificado', consolidated]] as const) {
    const sheet = XLSX.utils.json_to_sheet(data);
    sheet['!cols'] = Object.keys(data[0] || {}).map(key => ({ wch: Math.min(55, Math.max(14, key.length + 4)) }));
    sheet['!autofilter'] = { ref: sheet['!ref'] || 'A1:A1' };
    XLSX.utils.book_append_sheet(workbook, sheet, name);
  }
  XLSX.writeFile(workbook, 'Projetos-e-Amostras-modelo-comparativo.xlsx');
}
